import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { AppEnvironment } from "../types/AppEnvironment";

interface EnvironmentSelectorProps {
    environments: AppEnvironment[];
    selected: string;
    onChange: (name: string) => void;
}

function EnvironmentSelector({ environments, selected, onChange }: EnvironmentSelectorProps) {
    if (environments.length <= 1) {
        return null;
    }

    return (
        <FormControl size="small" style={{ minWidth: "14em" }}>
            <InputLabel id="app-environment-selector-label">Corporate site</InputLabel>
            <Select
                labelId="app-environment-selector-label"
                value={selected}
                label="Corporate site"
                onChange={event => onChange(event.target.value)}
            >
                {environments.map(environment => (
                    <MenuItem key={environment.name} value={environment.name}>
                        {environment.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default EnvironmentSelector;
